<header *ngIf="checkShowheader" class="header header-adisco mb-0" id="header">
    <div class="burger-wrap" [ngClass]="{ open: isShowNav }" (click)="onToggleNav()">
        <span class="burger"> </span>
        <span class="burger"> </span>
        <span class="burger"> </span>
    </div>
    <!-- header top -->
    <div class="header-top">
        <div class="container">
            <div class="header-top-inner d-flex justify-content-between align-items-center">
                <a class="logo-adisco">
                    <img (click)="onRedirecHome()" src="assets/logo/logo-ironside.png" alt="" />
                </a>
                <a *ngIf="logoMember" routerLink="/" class="logo-member">
                    <img [src]="logoMember" alt="" />
                </a>
                <div class="group-link d-flex justify-content-between align-items-center">
                    <div
                        *ngIf="isPermissionMenu('compare')"
                        (click)="checkShowPopup()"
                        class="wrap-comparer"
                    >
                        <button
                            class="btn-comparator d-flex justify-content-between align-items-center"
                            [ngClass]="{ open: checkShow }"
                        >
                            <img src="src-ironside/assets/icons/comparator.png" alt="" />
                            <p *ngIf="comparatorCount > 0" class="mb-0 count">
                                {{ comparatorCount }}
                            </p>
                            <p class="mb-0 products">{{ 'common.product' | translate }}</p>
                        </button>
                        <div *ngIf="checkShow" class="comparer">
                            <app-comparator></app-comparator>
                        </div>
                    </div>
                    <a
                        *ngIf="isPermissionMenu('favoris')"
                        href="#"
                        routerLink="/my-favorites"
                        class="d-flex justify-content-between align-items-center"
                    >
                        <div class="icon-heart-wrap"></div>
                    </a>
                    <a
                        *ngIf="isPermissionMenu('notifications')"
                        href="javascript:void(0)"
                        class="d-flex justify-content-between align-items-center icon-bell"
                        (click)="notificationsShowPopup()"
                    >
                        <svg
                            class="icon-bell"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                        >
                            <path
                                d="M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
                            />
                        </svg>
                        <span *ngIf="unreadMsgCount > 0" class="number">{{ unreadMsgCount }}</span>
                    </a>
                    <a
                        href="javascript:void(0)"
                        class="d-flex justify-content-between align-items-center icon-lang"
                        [matMenuTriggerFor]="langMenu"
                    >
                        <div class="icon-lang-wrap"></div>
                        <span class="current-language">{{ currentLangCode | uppercase }}</span>
                        <mat-menu class="lang-menu" #langMenu="matMenu">
                            <button
                                mat-menu-item
                                *ngFor="let lang of langs"
                                (click)="onTranslate(lang.code)"
                            >
                                <img
                                    [src]="'assets/icon/' + lang.code + '-flag.png'"
                                    [alt]="lang.code"
                                    style="width: 24px; height: 26px"
                                />
                                <span style="margin-left: 6px">{{
                                    'language.' + lang.text | translate
                                }}</span>
                            </button>
                        </mat-menu>
                    </a>
                    <a
                        *ngIf="isPermissionMenu('compte')"
                        href="/my-account"
                        class="d-flex justify-content-between align-items-center icon-bell"
                        style="border-right: 1px solid #000000"
                    >
                        <div class="icon-user-wrap"></div>
                    </a>
                    <a
                        href="#"
                        class="d-flex justify-content-between align-items-center icon-bell"
                        routerLink="/logout"
                    >
                        <div class="icon-logout-wrap"></div>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <!-- navigation -->
    <div class="wrap-nav" [ngClass]="{ open: isShowNav }">
        <div class="container">
            <div class="nav">
                <ul
                    class="w-100 p-0 mb-0 list-none menu menu-lv1 d-flex justify-content-between align-items-center"
                >
                    <li
                        *ngFor="let nav of getFilteredNavOptions(); let i = index"
                        [ngClass]="{
                            active:
                                (nav.ref == 'contact' && isMachinesActiveContact) ||
                                (nav.ref == 'product' && isMachinesActive)
                        }"
                        (mouseover)="openSubMenu(nav)"
                        (mouseleave)="delClassOverlay()"
                        (click)="menuClick(nav)"
                        [routerLink]="nav.route"
                        [routerLinkActive]="
                            nav.ref == 'product' || nav.ref == 'contact' ? '' : 'active'
                        "
                        [ngStyle]="{ width: 'calc(100% / ' + getFilteredNavOptions().length + ')' }"
                    >
                        <div class="d-flex gap-4 align-items-center item-nav">
                            <a
                                *ngIf="isPermissionMenu(nav.ref)"
                                [ngStyle]="{
                                    'border-right':
                                        getFilteredNavOptions().length > 0 &&
                                        i !== getFilteredNavOptions().length - 1 &&
                                        !isMobile
                                            ? '1px solid #fff'
                                            : ''
                                }"
                                >{{ 'Menu.' + nav.ref | translate }}</a
                            >

                            <ng-container
                                *ngIf="isMobile && nav?.subMenu && hoveredNav !== nav.ref"
                            >
                                <i class="pi pi-angle-right icon-expand"></i>
                            </ng-container>
                            <ng-container
                                *ngIf="isMobile && nav?.subMenu && hoveredNav === nav.ref"
                            >
                                <i class="pi pi-angle-down icon-expand"></i>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="nav?.subMenu">
                            <div
                                class="menu menu-lv2"
                                *ngIf="
                                    (hoveredNav == 'product' && nav.ref == 'product') ||
                                    (hoveredNav == 'contact' && nav.ref == 'contact')
                                "
                            >
                                <ul class="list-none p-0">
                                    <li *ngFor="let d2 of nav?.subMenu" (click)="onToggleNav(d2)">
                                        <div
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <a
                                                style="margin: 4px 6px !important"
                                                (click)="onRedirecProductList(d2.route)"
                                                class=""
                                                >{{ 'Menu.' + d2.ref | translate }}
                                                <ng-container
                                                    *ngIf="
                                                        isMobile && d2?.subMenu && !showBrandMenu
                                                    "
                                                >
                                                    <i class="pi pi-angle-right icon-expand"></i>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="isMobile && d2?.subMenu && showBrandMenu"
                                                >
                                                    <i class="pi pi-angle-down icon-expand"></i>
                                                </ng-container>
                                            </a>
                                        </div>

                                        <!--  [ngStyle]="{
                                                display: showBrandMenu ? 'block' : 'none'
                                            }" -->
                                        <div
                                            *ngIf="d2?.subMenu"
                                            [ngClass]="
                                                isMobile && showBrandMenu
                                                    ? 'menu-lv3-mobile'
                                                    : 'menu-lv3 menu'
                                            "
                                            class=""
                                        >
                                            <ul
                                                class="list-none p-0 d-flex justify-content-between align-items-center"
                                            >
                                                <ng-container *ngFor="let d3 of d2.subMenu">
                                                    <li *ngIf="(d3?.count ?? 0) > 0">
                                                        <a
                                                            style="
                                                                font-family: Poppins;
                                                                margin: 4px 20px !important;
                                                            "
                                                            (click)="goToSearchPage(d3)"
                                                            class="d-flex gap-2 align-items-center"
                                                        >
                                                            {{
                                                                d3?.title | translateDynamicLanguage
                                                            }}
                                                        </a>
                                                    </li>
                                                </ng-container>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</header>
<div *ngIf="currentUrl !== '/home' && currentUrl !== '/import'">
    <app-keyword-search></app-keyword-search>
</div>
<ng-container *ngIf="notificationsPopup">
    <app-notification-list (onClosed)="notificationsShowPopup()"></app-notification-list>
</ng-container>

<!-- header disco -->
